export const CADREQ_ISMART_1F = 31;
export const CADREQ_ISMART_2F = 32;
export const I_SMART_TYPE = 1;

export const HEATING_COOKING_EQUIPMENT = 99; //2026-05-12 jazz 

export const JAPANESECAD_REQUEST_PROCEDURE_ENGLISH = 'Please go back to CRS and click the "保存" button to proceed with cad request creation.' //added line 2025-11-18 jazz
export const CAD_REQUEST_PROCEDURE_JAPANESE = 'CRSに戻り、「保存」ボタンを押してCAD依頼の作成を続けてください。' //added line 2025-11-18 jazz
export const ZERO_VAL = 0;
export const INITIAL_VAL = 1;
export const MAINCATEGORY_GROUPID = 1;
export const CATEGORY_GROUPID = 2;
export const EDIT = 'edit';
export const SYSTEM_NAME = 'SRS';
export const SOCKET_LISTENER = 'localserver@'; //2025-05-27 jazz
export const EMPTY_STR = '';
export const STANDARD_PLAN_LENGTH = 12;
export const PLANNER_COMPLETED = 1;
export const RETRY_COUNT = 12;
// export const MAX_MULTIPLE_ITEM_COUNT = 17;
export const SHIO_COMPLETED = 2;
export const SUCCESS = 200;
export const FAILED = 500;
export const TIMEOUT = 5000; //milliseconds //for axios
export const WEBSOCKET_TIMEOUT = 40
export const BOSS_SENDING_TIMEOUT = 10
export const SEND_TO_LOCAL_TIMEOUT = 10 //2026-10-08 jazz, seconds to wait for isSendToLocal websocket confirmation before retrying
export const SAVING_DATA = 'セーブデータ'
export const VALIDATING_DATA = '資格情報の検証'
export const LOADING = 'ローディング'
export const UPDATING_MASTER = 'マスターの更新'
export const PROGRESS_FULL = 100
export const THIRD_FLOOR_KANJI = '3階建';
export const THIRD_FLOOR_KANJI2 = '3階';
export const LOADING_SRS_UPDATES = 'SRS アップデートのロード';
export const MAX_ADDITIONAL_ITEM_VALUE = 30
export const GAIBU_MASTER = 1
export const KIHON_MASTER_UI_INDEX = 0
export const SETSUBI_MASTER = 2
export const GAIBU_USERINTERFACE = 'GaibuList'
export const SETSUBI_USERINTERFACE = 'SetsubiSheet'
export const KIHON_USERINTERFACE = 'BasicSpecs'
export const KIHON_MASTER = 3
export const EXTERNAL_SITE_REFERRER = 'AcceptRedirect'
export const TOILETS_AND_SYSTEM_BATH = [20, 173, 452, 136]
export const SYSTEM_BATH_ID = 136
export const TOILET_1F_ID = 20
export const TOILET_2F_ID = 173
export const TOILET_3F_ID = 452
export const GENKAN_DOOR_ID = 2508
export const FOR_EDIT = 0
export const SINGLE_FLOORING_INTERFACE = [0, 4, 11, 14, 99, 991, 18] //Added Line 2026-01-20 jazz, added single flooring
export const FIRST_FLOOR_ID = 60
export const SAVING_DATA_JAPANESE = 'データを保存中。しばらくお待ちください。'
export const CHECKING_BOSS_DATA = 'BOSSデータを確認しています。'
// export const SENDING_DATA_JAPANESE = 'データを送信中。しばらくお待ちください。'
export const SENDING_DATA_HRD = 'HRD にデータを送信しています...'
export const SENDING_DATA_BOSS = 'BOSS にデータを送信しています...'
export const WEB_WORKER_NOT_AVAILABLE_JAPANESE = 'ウェブワーカーは利用できません。他のブラウザを使用してください。';
export const WEB_WORKER_NOT_AVAILABLE_ENGLISH = 'Webworker not available, please use other browser';
export const INVALID_DETAILS = '無効な詳細が入力されました。 </br>You entered an invalid details';
export const ALREADY_HAS_CONNECTION_IN_SOCKET = 'The email you entered has already an active websocket connection.\n\nYou can proceed to use SRS but without websocket connection.';
export const CREATION_IS_NOT_POSSIBLE_JAPANESE = "でに同じ図面・仕様書番号で、<br>データ送信されているため、<span style='color:red;'>作成は不可</span>です。"
export const COPY_NOT_POSSIBLE='ネットワークエラーです。以前のプランからデータをコピーできません。当面は新しいプランを作成してください。\n\nNetwork error. Copying of data from previous is not possible. For the meantime, you can create as new plan.';
export const SAVE_AS_DRAFTS_WARNING_JAPANESE = '入力した情報は下書きとして保存されます。\nよろしいですか？'
export const SAVE_AND_SEND_WARNING_JAPANESE = '送信後は、編集不可となります。\n送信してよろしいですか？'
export const SUCCESS_GENERATE_PDF = 'Success creating PDF file\nPlease check your download folder'
export const SUCCESS_GENERATE_PDF_JAP = 'PDFファイルの作成に成功しました。ダウンロードフォルダをご確認ください。'


export const SUCCESS_SENDING_IN_HRD = 'HRDで成功裏に送信しました'
export const FAILED_SENDING_IN_HRD = 'HRDでの送信に失敗しました'
export const SUCCESS_SENDING_IN_BOSS = 'BOSSで成功裏に送信しました'
export const FAILED_SENDING_IN_BOSS = 'BOSSでの送信に失敗しました'
export const WARNING_UPDATE_SRS_MASTER_JAP = 'この操作によりSRSマスターが更新されます。よろしいですか？'
export const WARNING_UPDATE_SRS_MASTER_ENGLISH = 'This action will update SRS Master.<br>Is it OK?'

export const DISPLAY_AVAILABLE_REQUEST_NUMBER = 'displayShio@new_plan'

//2025-04-02 jazz
export const STORAGE_CD = '0500';
export const STORAGE_MASTER_NAME_KANJI = '収納';
export const NAIBU_MASTER_NAME_KANJI = '内部';

export const BATHROOM_TV = 3058;

// //2025-03-31 jazz
// export const NOT_DISPLAY_SURYO_1 = ['9999999', '0000002'];
// export const MONOHOSHI_KANAMONO_CD = '0110';
// export const INDOOR_CLOTHES_LINE_CD = '0340';

//added 2024-10-07 ==Custom Change the Item name==
export const SYSTEM_KITCHEN_HANGING_CUPBOARD_ID = [2659];
export const CHECK_HOUSE_TYPE = [11, 14, 0, 4]; //hugme, hugmefam, smileII, smileII+
export const SYSTEM_KITCHEN_HEATING_EQUIPMENT_ID = [41515, 41516, 41517, 41518];
export const KAMIDANA_HEMS_PARENTID = [2941, 4939]  ; //added mae 2025-06-24
// export const GENKAN_DOOR_TYPE_ID = [415010]  ; //added mae 2025-09-01
// export const GENKAN_DOOR_TYPE_LABEL = 'ファノーバ2/耐水害用'; //added mae 2025-09-01


             //for トイレ収納|トイレ手摺 and トイレ収納|トイレ手摺  Category and subcategory retain  
             export const TOILETS_CATEGORY_ID = [
                4823, 
                2716,  //1F to 2F トイレ収納  subcategory
                4149, 3317, 4796, 4827, 4833, 4839,//1F to 2F トイレ手摺
                4185,  
                4781, 4797, 2743, 2693, 41500, //2025-05-07 jazz
                2740, 2703
                ]

//for トイレ収納|トイレ手摺 retain Category only  (without SubCategory)
export const TOILETS_CATEGORY_ID_RETAINOBJ = [
                            2743, 41500, //2025-05-07 jazz
                            2740, 4823,   
                            4149, 3317, 4796,
                            4827, 
                            4833, 4839
                        ]

//retain subcategory
export const TOILETS_SUBCATEGORY_ID_RETAINOBJ = [
                                2716,
                                4185, 
                                4781, 
                                4797,
                                2693,
                                2703
                            ]


export const TOILETS_STORAGE_IDS = [    //
                      4823, 2743, 2740, 41500, //2025-05-07 jazz
                    4149, 3317, 4796, 4827, 4833, 4839 //TOILETS_TESURI_IDS =mae added 2025-08-23=
                ]

// export const TOILETS_TESURI_IDS = [4149, 3317, 4796, 4827, 4833, 4839]

export const WATER_SUPPLY_CONST_ID = 2448; //mae added 2025-07-23 => if 給水工事 nashi hide add item
export const WATER_SUPPLY_CONST_ID_LIST = [1109, 1110, 1111, 1112] //mae added 2025-07-23 => if 給水工事 nashi hide add item
export const WATER_SUPPLY_NASHI = 1108; //Added Line 2026-07-07 jazz

export const trigger_textureid_to_uncheckItems = [146, 6906]  //with キッチン壁 (temporary only) mae added 2024-08-17
export const trigger_textureid_to_uncheckItems2 = [206,217,785] //without キッチン壁 (temporary only) mae added 2024-08-17

//For Jiban
export const JIBAN_UNINVESTIGATED_SEQUENTIAL_NO = 99
export const JIBAN_UNINVESTIGATED_SRS_ID = 4543
export const JIBAN_DECISION_SRS_VALUE_ID = 1000
export const MONOHOSHI_KANAMONO = 124;
export const MONOHOSHI = 4901;
export const BUILDING_SITE = 3044;
//UI Buttons
export const COPY_FROM_SPECIFICATION_JAPANESE = 'コピーして入力(仕様書)'
export const COPY_JAPANESE = 'ｺﾋﾟｰして入力(Copy)'

//Dialogs
export const CHANGE_ROUTE_WARNING_ENGLISH = 'Do not save displayed data move or exit.\nIs it OK?';
export const CHANGE_ROUTE_WARNING_JAPANESE = '表示されているデータを保存しないで\n移動または終了します。よろしいですか？\n'
export const WEBSOCKET_CONNECTION_FAILED_WARNING_ENGLISH = 'Failed to connect to websocket.\nPlease try again.';
export const WEBSOCKET_CONNECTION_FAILED_WARNING_JAPANESE = '(WebSocket)接続に失敗しました。\n再度、やり直して下さい。\n\n'
export const FAILED_TO_READ_DATA_JAPANESE = 'データ読込に失しました。\n再度、ログインしてください。\n現銀が改善されない場合は、システム管理者に連絡をください。'
export const RETRY_LOADING_DATA_JAPANESE = 'データの読み込みを再試行しますか?'
export const NO_PREVIOUS_SHIO_PLAN_ENGLISH = 'There is no previous Shiyousho plan'
export const NO_PREVIOUS_SHIO_PLAN_JAPANESE = '以前のシヨウショウプランはありません\n\n'
export const ALREADY_SAVED_FOR_EDIT_WARNING_JAPANESE = '本図面番号で、すでに作成・保存済です。「保存データから始める(Edit)」でデータを取得し、編集、送信して下さい。'
export const ALREADY_SAVED_FOR_EDIT_WARNING_ENGLISH = 'This plan number`s data is already created & saved. Please get from “Edit” and edit and send it.'
export const ALREADY_SENT_TO_BOSS_WARNING_JAPANESE = '計画はすでに BOSS と HRD に送信されています。'
export const ALREADY_SENT_TO_BOSS_WARNING_ENGLISH = 'The plan has already been sent to BOSS and HRD.'
export const PLAN_ALREADY_EXIST_JAPANESE = 'すでに同じ仕様書番号でデータが保存されているため、「作成(Create)」での作成は不可です。\n\n「保存データから始める(Edit)」にて、編集を行って下さい。'
export const SUCCESS_SAVING_PLAN = 'プランの保存に成功しました \n(Successfully Saved)';
export const FAILED_SAVING_PLAN = 'プランは保存されませんでした。ネットワーク接続にエラーがあるようです。 \nSRS を更新し、プランを再送信してください。 \n\nThe plan was not saved. There seems to be an error in the network connection. \nPlease update your SRS and resubmit your plan.'
// export const NEW_VERSION_INFO = '新しいバージョンのリリースがあります。\nThere is new version release( -####- ).\n\n更新しますか?'
 
//Added Line 2026-03-07 jazz
export const SRS_REQUEST_EMPTY_JAPANESE = 'このプランを保存できません。SRS リクエストが空です。'
export const SRS_REQUEST_EMPTY_ENGLISH = 'Not possible to save this plan, SRS Request is empty.'


export const NEW_VERSION_INFO = '新しいバージョンのリリースがあります( -####- )。<br>更新しますか?'
export const NEW_VERSION_INFO_EN = 'There is new version release( -####- ).<br>Do you want to update?'

export const CHANGES_WILL_TAKE_EFFECT_NEXT_PLAN_CREATION = '変更は次回のプラン作成時に有効になります。<br><br>Changes will take effect on next plan creation.'

//2025-04-02 jazz
export const NO_SHIO_PDF_JAP = '仕様書のPDFは利用できません';
export const NO_SHIO_PDF_EN = 'No specification sheet pdf available';

//mae added for user restriction message in saving data 2024-12-19
export const USER_INTERUPT_SAVING_PROCESS = 'あなたは貯蓄のための継続的な計画を持っています。\nページの再読み込みにより、保存されていないデータや失われたデータが発生する可能性があります。\nページの更新を続行してもよろしいですか? \n\nYou have an ongoing plan for saving. \nReloading the page can result in unsaved or lost data. \nAre you sure you want to continue reloading the page?'
export const RESUBMIT_UNSAVED_PLAN = 'プランは保存されませんでした。\n保存したい場合は、再度プランを提出してください。\n\nThe plan was not saved. \nIf you want to save it, please submit your plan again.'
export const WAITING_INFO = '保存プロセスが正常に完了するまでお待ちください。 \n\nKindly wait until the saving process is successfully completed.'

//mae added for cancel request 2025-07-31
export const CANCEL_PLAN_WARNING_ENGLISH = 'Are you sure you want to cancel  the sent request?';
export const CANCEL_PLAN_WARNING_JAPANESE = '表示されている送信済依頼をキャンセルしますが、よろしですか。';
export const CANCEL_PLAN_SUCCESS_ENGLISH = 'Cancellation successful. \nNOTE: This is just a test only. No changes made in the data.';
export const CANCEL_PLAN_SUCCESS_JAPANESE = 'キャンセル完了。';
export const CANCEL_PLAN_NOT_ALLOWED_ENGLISH = 'Cancellation is not allowed.';
export const CANCEL_PLAN_NOT_ALLOWED_JAPANESE = 'キャンセル不可。';

//2025-04-05 jazz Dialog infos
export const DIALOG_INFO_ARR = [
                                    {
                                        planStatusName: 'drafts',
                                        planStatusCode: 0,
                                        dialogTitle   : '編集(Edit)',
                                        createDateLabel: '保存日時'

                                    },
                                    {
                                        planStatusName: 'completed',
                                        planStatusCode: 2,
                                        dialogTitle   : '仕様書(Completed)',
                                        createDateLabel: '送信日時'   
                                    },                     
                                    {
                                        planStatusName: 'shiyocompleted',
                                        planStatusCode: 2,
                                        dialogTitle   : '仕様書(Shiyousho Completed)',
                                        createDateLabel: '送信日時'   
                                    },                     
                                ];

//2025-04-05 jazz
export const FINAL_PLAN = '1';
export const FINAL_PLAN_REMARKS = '<span style="color: blue;">【FP】</span>';

//2025-05-09 jazz
export const DISPLAY_ALL = 0;
export const DISPLAY_BY_ITEM = 1;

//205-08-14 jazz, offset
// export const TABLE_RENDER_OFFSET = 10;

export const OBSOLETED_IN_HOUSETYPE = [11,14,18]; //2026-03-31 mae added. temporary only. for deletion once the item officially obsoleted



